import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection,
  AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class SalesAnalyticsService {

  totalVisits;
  totalCallbacks;


  leadsCollection: AngularFirestoreCollection;
  deadCollection: AngularFirestoreCollection;
  convertedCollection: AngularFirestoreCollection;
  visits: AngularFirestoreCollection;
  callbackReq: AngularFirestoreCollection;
  analyticsObs: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(private afs: AngularFirestore) {
    this.leadsCollection = this.afs.collection('leads', ref => ref.orderBy('updatedAt', 'desc'));
    this.deadCollection = this.afs.collection('dead', ref => ref.orderBy('markedAt', 'desc'));
    this.convertedCollection = this.afs.collection('converted', ref => ref.orderBy('markedAt', 'desc'));
    this.visits = this.afs.collection('visits');
    this.callbackReq = this.afs.collection('callbackRequest');

    this.leadsCollection.valueChanges().subscribe((snapshot) => {
      let tCount = snapshot.length;
      console.log("Analytics Snapshot is ", snapshot);
      let groupMap = this.groupBy(snapshot, (row)=> {return row.status});
      console.log("Stage clubbing is ", groupMap);

      snapshot.map((entry)=>{

      })
    });

    this.visits.valueChanges().subscribe((snapshot) => {
      let tCount = snapshot.length;
      console.log("Total Visits scheduled ", tCount);
      snapshot.map((entry)=>{

      })
    });

    this.callbackReq.valueChanges().subscribe((snapshot) => {
      let tCount = snapshot.length;
      console.log("Total Callback Requests ", tCount);
      snapshot.map((entry)=>{

      })
    });


    this.deadCollection.valueChanges().subscribe((snapshot) => {
      let tCount = snapshot.length;
      console.log("Analytics Snapshot: dead collection ", snapshot);
      let groupMap = this.groupBy(snapshot, (row)=> {return row.reason});
      console.log("Reason clubbing is ", groupMap);
      snapshot.map((entry)=>{

      })
    });

    this.convertedCollection.valueChanges().subscribe((snapshot) => {
      let tCount = snapshot.length;
      console.log("Analytics Snapshot: converted collection ", snapshot);
      snapshot.map((entry)=>{

      })
    });

  }

  private groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}
}
